import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";
import { redirect } from "@state";
import { getCurrentCulture } from "@utils";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default observer(function SupportChatInfoPopup() {
	const { t } = useTranslation();
	const { chatViewStore } = useRootAppStore();

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Mobile/SupportChatInfoPopup.tsx"}
		>
			<div className="at-supportChatInfoModal popup">
				<div className="popup__card">
					<div className="popup__header">
						<div className="popup__title">{t("LIVE.INFO")}</div>
						<button
							type="button"
							className="btn btn--icon btn--square btn--square--sml btn--primary--inverted"
							onClick={() =>
								chatViewStore.toggleSupportChatPopup(false)
							}
						>
							<i className="u-icon u-icon--sml u-icon--close" />
						</button>
					</div>
					<div className="popup__body">
						<div>
							<p>{t("CHAT.SUPPORT.INFO.WELCOME_SENTENCE")}</p>
							<ul className="list list--disc">
								<li>
									{t("CHAT.SUPPORT.INFO.ISSUE_INSTRUCTION")}
								</li>
								<li>
									{t(
										"CHAT.SUPPORT.INFO.UPLOAD_DOCUMENT_INSTRUCTION"
									)}
								</li>
							</ul>
						</div>
						<p>
							{t("CHAT.SUPPORT.INFO.THANK_YOU_SUPPORT_SENTENCE")}
						</p>
					</div>
					<div className="popup__footer">
						<button
							type="button"
							className="popup__btn popup__btn--secondary btn btn--base btn--block btn--primary--inverted btn--icon"
							onClick={() => {
								chatViewStore.toggleSupportChatPopup(false);
								redirect(`/${getCurrentCulture()}/info/help`);
							}}
						>
							<span className="btn__label">
								{t<string>("FOOTER.HELP")}
							</span>
							<i className="u-icon u-icon--tny u-icon--arrow-right" />
						</button>
					</div>
				</div>
			</div>
		</ErrorBoundaryWithPropagation>
	);
});
